import { AdminMixerService } from '@linktivity/triplabo-taxfree';

export const CommonAccountStatus = AdminMixerService.CommonAccountStatus;
export type CommonAccountStatus = AdminMixerService.CommonAccountStatus;

export const CommonAuthType = AdminMixerService.CommonAuthType;
export type CommonAuthType = AdminMixerService.CommonAuthType;

export const CommonGender = AdminMixerService.CommonGender;
export type CommonGender = AdminMixerService.CommonGender;

export const CommonGoodType = AdminMixerService.CommonGoodType;
export type CommonGoodType = AdminMixerService.CommonGoodType;

export const CommonMode = AdminMixerService.CommonMode;
export type CommonMode = AdminMixerService.CommonMode;

export const CommonNationality = AdminMixerService.CommonNationality;
export type CommonNationality = AdminMixerService.CommonNationality;

export const CommonNotificationStatus =
  AdminMixerService.CommonNotificationStatus;
export type CommonNotificationStatus =
  AdminMixerService.CommonNotificationStatus;

export const CommonNotificationType = AdminMixerService.CommonNotificationType;
export type CommonNotificationType = AdminMixerService.CommonNotificationType;

export const CommonNtaResult = AdminMixerService.CommonNtaResult;
export type CommonNtaResult = AdminMixerService.CommonNtaResult;

export const CommonNtaShopType = AdminMixerService.CommonNtaShopType;
export type CommonNtaShopType = AdminMixerService.CommonNtaShopType;

export const CommonOrderStatus = AdminMixerService.CommonOrderStatus;
export type CommonOrderStatus = AdminMixerService.CommonOrderStatus;

export const CommonPermitDocumentType =
  AdminMixerService.CommonPermitDocumentType;
export type CommonPermitDocumentType =
  AdminMixerService.CommonPermitDocumentType;

export const CommonPermitType = AdminMixerService.CommonPermitType;
export type CommonPermitType = AdminMixerService.CommonPermitType;

export const CommonRefundMethod = AdminMixerService.CommonRefundMethod;
export type CommonRefundMethod = AdminMixerService.CommonRefundMethod;

export const CommonRefundStatus = AdminMixerService.CommonRefundStatus;
export type CommonRefundStatus = AdminMixerService.CommonRefundStatus;

export const CommonRegiType = AdminMixerService.CommonRegiType;
export type CommonRegiType = AdminMixerService.CommonRegiType;

export const OcrImageType = AdminMixerService.OcrImageType;
export type OcrImageType = AdminMixerService.OcrImageType;

export const OcrMimeType = AdminMixerService.OcrMimeType;
export type OcrMimeType = AdminMixerService.OcrMimeType;
